import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { LocationInfo } from '../components/LocationInfo.js';

const LocationInfoContainer = ({ location: location1 , onEdit , showMessage =true , showOpeningHours  })=>{
    const { isStorePickupPhoneEnabled  } = useFeatureToggles();
    const { getLabel , hasLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            message: getLabel('checkout.locationInfo.message', {
                hideLabelKey: true
            })
        })
    , [
        getLabel
    ]);
    const isStore = React.useCallback((location)=>'phone' in location
    , []);
    const message = labels.message && showMessage ? /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        className: "alert-m-default"
    }, labels.message) : null;
    const title = isStore(location1) ? 'checkout.locationInfo.store.label' : 'checkout.locationInfo.pickupPoint.label';
    return /*#__PURE__*/ React.createElement(LocationInfo, swcHelpers.extends({
        isStorePickupPhoneEnabled: isStorePickupPhoneEnabled,
        location: location1,
        message: message,
        onEdit: onEdit,
        showOpeningHours: showOpeningHours,
        isStore: isStore
    }, hasLabel(title) ? {
        title: getLabel(title)
    } : null));
};

export { LocationInfoContainer };
//# sourceMappingURL=LocationInfoContainer.js.map
